import React from 'react';
import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import { PageMainLabel } from 'app/components/SHLabel';
import styled, { createGlobalStyle } from 'styled-components';
import SchoolTeamLeaderPointTable from './SchoolTeamLeaderPointTable';
import LeaderPointTeamHeaderCell from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/LeaderPointTeamHederCell';
import TeamNameLabelCell from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/TeamNameLabelCell';
import { ScoreBoard, ShowScoreBoardClasses } from 'services/openapi';
import {
  finalPlacingObject,
  teamHeaderObject,
  totalHeaderObject,
  updateData,
} from '../static';
import { ScorePointCell } from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/ScorePointCell';
import YedaLogo from 'app/components/admin/sidebar/assets/img/yeda-logo.png';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';

type Props = { showScoreBoardList: ScoreBoard | undefined; loading: boolean };

export const ScoreBoardPage = ({ showScoreBoardList, loading }: Props) => {
  const headerClassListJuniorHighSchoolteam =
    showScoreBoardList?.juniorHighSchoolteam?.classes;
  const headerClassListSeniorHighSchoolteam =
    showScoreBoardList?.seniorHighSchoolteam?.classes;
  const updatedJuniorHeaderCells = [
    teamHeaderObject,
    ...(typeof headerClassListJuniorHighSchoolteam === 'object' &&
      headerClassListJuniorHighSchoolteam !== null
      ? headerClassListJuniorHighSchoolteam
      : []),
    totalHeaderObject,
    finalPlacingObject,
  ];
  const updatedSeniorHeaderCells = [
    teamHeaderObject,
    ...(typeof headerClassListSeniorHighSchoolteam === 'object' &&
      headerClassListSeniorHighSchoolteam !== null
      ? headerClassListSeniorHighSchoolteam
      : []),
    totalHeaderObject,
    finalPlacingObject,
  ];
  const mappedSeniorHeaderCells = updatedSeniorHeaderCells?.map(headerCell => {
    const fieldName = headerCell?.code?.toLowerCase();
    return {
      field: fieldName,
      width: fieldName === 'team' ? '200' : '150',
      headerCell: props => (
        <LeaderPointTeamHeaderCell title={headerCell?.name!} />
      ),
      cell: e => {
        const cellComponent = ['team', 'total_point', 'final_placing'].includes(
          fieldName!,
        ) ? (
          <TeamNameLabelCell
            e={e}
            value={
              fieldName === 'team'
                ? e.dataItem.teamName
                : fieldName === 'total_point'
                  ? e.dataItem.total === 0 ||
                    e.dataItem.total === '' ||
                    e.dataItem.total === null
                    ? "-"
                    : e.dataItem.total
                  : fieldName === 'final_placing'
                    ? e.dataItem.finalPlacing === 0 ||
                      e.dataItem.finalPlacing === '' ||
                      e.dataItem.finalPlacing === null
                      ? "-"
                      : e.dataItem.finalPlacing
                    : ''
            }
          />
        ) : (
          <ScorePointCell value={e.dataItem[headerCell?.code!]} />
        );

        return cellComponent;
      },
    };
  });
  const mappedJuniorHeaderCells = updatedJuniorHeaderCells?.map(headerCell => {
    const fieldName = headerCell?.code?.toLowerCase();
    return {
      field: fieldName,
      width: fieldName === 'team' ? '200' : '150',
      headerCell: props => (
        <LeaderPointTeamHeaderCell title={headerCell?.name!} />
      ),
      cell: e => {
        const cellComponent = ['team', 'total_point', 'final_placing'].includes(
          fieldName!,
        ) ? (
          <TeamNameLabelCell
            e={e}
            value={
              fieldName === 'team'
                ? e.dataItem.teamName
                : fieldName === 'total_point'
                  ? e.dataItem.total === 0 ||
                    e.dataItem.total === '' ||
                    e.dataItem.total === null
                    ? "-"
                    : e.dataItem.total
                  : fieldName === 'final_placing'
                    ? e.dataItem.finalPlacing === 0 ||
                      e.dataItem.finalPlacing === '' ||
                      e.dataItem.finalPlacing === null
                      ? "-"
                      : e.dataItem.finalPlacing
                    : ''
            }
          />
        ) : (
          <ScorePointCell value={e.dataItem[headerCell?.code!]} />
        );

        return cellComponent;
      },
    };
  });
  const dataJuniorHighSchoolteam =
    showScoreBoardList?.juniorHighSchoolteam?.results;
  const updatedJuniorData = updateData(dataJuniorHighSchoolteam!);
  const updatedJuniorHighSchoolteamDataData = updatedJuniorData?.map(item => {
    const { classes, ...rest } = item;
    return rest;
  });
  const dataSeniorHighSchoolteam =
    showScoreBoardList?.seniorHighSchoolteam?.results;
  const updatedSeniorData = updateData(dataSeniorHighSchoolteam!);
  const updatedSeniorHighSchoolteamDataData = updatedSeniorData?.map(item => {
    const { classes, ...rest } = item;
    return rest;
  });
  return (
    <StyledCommonPageWrapper>
      <LandscapePrintStyle />
      <ScreenOnlyWrapper>
        {loading ? (
          <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
        ) : (
          <>
            <TitleCardWrapper>
              <HeadingWrapper className="heading-wrapper">
                <PageMainLabel className="label-wrapper">
                  Senior High School Team
                </PageMainLabel>
              </HeadingWrapper>
            </TitleCardWrapper>
            <SchoolTeamLeaderPointTable
              data={updatedSeniorHighSchoolteamDataData}
              columns={mappedSeniorHeaderCells}
            />
            <TitleCardWrapper className="junior-high-school">
              <HeadingWrapper className="heading-wrapper">
                <PageMainLabel className="label-wrapper">
                  Junior High School Team
                </PageMainLabel>
              </HeadingWrapper>
            </TitleCardWrapper>
            <SchoolTeamLeaderPointTable
              data={updatedJuniorHighSchoolteamDataData}
              columns={mappedJuniorHeaderCells}
            />
          </>
        )}
      </ScreenOnlyWrapper>
      <ScoreBoardPrintView
        showScoreBoardList={showScoreBoardList}
        seniorClasses={headerClassListSeniorHighSchoolteam}
        juniorClasses={headerClassListJuniorHighSchoolteam}
        seniorData={updatedSeniorHighSchoolteamDataData}
        juniorData={updatedJuniorHighSchoolteamDataData}
      />
    </StyledCommonPageWrapper>
  );
};

const StyledCommonPageWrapper = styled(CommonPageWrapper)`
  padding-top: 26px;
`;

// ---------- Print-only components ----------

const ScoreBoardPrintSection: React.FC<{
  title: string;
  classes: ShowScoreBoardClasses[] | null | undefined;
  data: Record<string, any>[] | undefined;
}> = ({ title, classes, data }) => {
  const cols = classes ?? [];
  const totalCols = cols.length + 3; // Team + dynamic classes + Total + Final Placing
  return (
    <>
      <tr className="section-title-row">
        <td colSpan={totalCols}>{title}</td>
      </tr>
      <tr className="col-header-row">
        <th className="team-col">Team</th>
        {cols.map((cls, i) => (
          <th key={i}>{cls.name}</th>
        ))}
        <th>Total</th>
        <th>Final Placings</th>
      </tr>
      {data?.map((row, idx) => (
        <tr key={idx} className={idx % 2 === 1 ? 'row-alt' : ''}>
          <td className="team-col">{row.teamName}</td>
          {cols.map((cls, i) => (
            <td key={i} className="score-cell">
              {row[cls.code!] ?? ''}
            </td>
          ))}
          <td className="score-cell total-cell">{row.total ?? ''}</td>
          <td className="score-cell">{row.finalPlacing ?? ''}</td>
        </tr>
      ))}
    </>
  );
};

const ScoreBoardPrintView: React.FC<{
  showScoreBoardList: ScoreBoard | undefined;
  seniorClasses: ShowScoreBoardClasses[] | null | undefined;
  juniorClasses: ShowScoreBoardClasses[] | null | undefined;
  seniorData: Record<string, any>[] | undefined;
  juniorData: Record<string, any>[] | undefined;
}> = ({ seniorClasses, juniorClasses, seniorData, juniorData }) => (
  <PrintTableWrapper>
    <div className="print-logo">
      <img src={YedaLogo} alt="YEDA" />
    </div>
    <table className="print-table">
      <tbody>
        <ScoreBoardPrintSection
          title="Senior High School Team"
          classes={seniorClasses}
          data={seniorData}
        />
      </tbody>
    </table>
    <div className="page-break" />
    <table className="print-table">
      <tbody>
        <ScoreBoardPrintSection
          title="Junior High School Team"
          classes={juniorClasses}
          data={juniorData}
        />
      </tbody>
    </table>
  </PrintTableWrapper>
);

// ---------- Landscape print override ----------

const LandscapePrintStyle = createGlobalStyle`
  @media print {
    @page {
      size: landscape;
      margin: 8mm;
    }
  }
`;

// ---------- Styled Components ----------

const ScreenOnlyWrapper = styled.div`
  @media print {
    display: none;
  }
`;

const PrintTableWrapper = styled.div`
  display: none;
  @media print {
    display: block;
    width: 100%;
  }
  .page-break {
    @media print {
      page-break-before: always;
      break-before: page;
    }
  }
  .print-logo {
    display: none;
    @media print {
      display: block;
      margin-bottom: 10px;
      img {
        width: 85px;
        height: auto;
      }
    }
  }
  .print-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 7px;
    font-family: 'Inter', Arial, sans-serif;
    color: #000;
    page-break-inside: auto;
    table-layout: auto;
  }
  .print-table th,
  .print-table td {
    border: 1px solid #ccc;
    padding: 2px 3px;
    text-align: center;
    vertical-align: middle;
    white-space: normal;
    word-break: break-word;
  }
  .team-col {
    text-align: left;
    white-space: normal;
    min-width: 90px;
  }
  .score-cell {
    min-width: 25px;
  }
  .total-cell {
    font-weight: 700;
  }
  .section-title-row td {
    background-color: #e7ecff;
    font-weight: 700;
    font-size: 10px;
    text-align: center;
    padding: 4px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .col-header-row th {
    background-color: #eaecf0;
    font-weight: 600;
    font-size: 7px;
    white-space: normal;
    word-break: break-word;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .row-alt td {
    background-color: #f7f9fc;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  tr {
    page-break-inside: avoid;
  }
`;

export const TitleCardWrapper = styled.div`
  &.junior-high-school {
    margin-top: 52px;
  }
  margin: 0px 0px 0px 0px;
  background-color: #e7ecff;
  .heading-wrapper {
    padding: 14px 0px 14px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    .label-wrapper {
      font-family: 'Inter';
      font-size: 14px;
      font-weight: 600;
      line-height: 14.52px;
      color: #000000;
      margin: unset !important;
    }
  }
`;
